import { AuthCredentialType } from '../enums/auth-credential-type';

export type LoginRequestPayload = {
  email: string;
  password: string;
  captchaToken?: string;
};

export type SignupRequestPayload = {
  email: string;
  timeZone: string;
  rewardfulReferralId: string;
  isLtdUser?: boolean;
  password?: string;
  landingPage?: string;
  captchaToken?: string;
};

export type VerifyUserVerificationCodeRequestPayload = {
  email: string;
  code: number;
};

export type ResendUserVerificationCodeRequestPayload = {
  email: string;
};

export type ResetPasswordRequestPayload = {
  email: string;
  captchaToken?: string;
};

export type ChangePasswordRequestPayload = {
  password: string;
};

export type UserSetPasswordPayload = {
  newPassword: string;
};

export type AcceptInvitationRequestPayload = {
  token: string;
  timeZone: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  password: string;
};

export type OnBoardingRequest = {
  industry?: string;
  designation: string;
  teamSize?: string;
  useCase: string;
};

/** Payload for POST /onboarding/submit (signup onboarding modal) – backend keys */
export type OnboardingSubmitRequest = {
  countryCode: string;
  phoneNumber: string;
  industry: string;
  companySize: string;
  mailboxCount: string;
  monthlyEmailVolume: string;
  /** Optional: ISO datetime for high-intent slot booking */
  selectedSlot?: string;
};

/** Single slot from GET user/onboarding/available-slots (API may send startTime; normalized to time in slice) */
export type AvailableSlot = {
  time: string;
  inviteesRemaining: number;
  /** Raw API field; used when normalizing to time */
  startTime?: string;
  endTime?: string;
  status?: string;
};

/** Response from GET user/onboarding/available-slots */
export type AvailableSlotsResponse = {
  data: { slots: AvailableSlot[]; timezone?: string };
  success: boolean;
};

export type SetPasswordRequest = {
  firstName: string;
  lastName: string;
  phone?: string;
  password: string;
  email: string;
  country: string;
};

export enum ActionForAuthentication {
  Signup = 'signup',
  Login = 'login',
  ChangeEmail = 'change-email',
  ValidationChangeEmail = 'validation-change-email',
  Invitation = 'invitation',
  DeleteAccount = 'delete-account',
}

export type OAuthPayload = {
  timeZone: string;
  action: ActionForAuthentication;
  userId?: number;
  invitedEmail?: string;
  landingPage?: string;
  rewardfulReferralId?: string;
};

export type OAuthAuthenticateExtras = {
  credentialType?: AuthCredentialType;
  action?: ActionForAuthentication;
  utmSource?: string;
  timeZone?: string;
  rewardfulReferralId?: string;
};

export type GoogleOneTapStashedPayload = {
  credential: string;
  action?: ActionForAuthentication;
  utmSource?: string;
  rewardfulReferralId?: string;
};
